











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskFooterUserAssigneeMenuRoot_task",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskFooterUserAssigneeMenu_task"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node ).hash = "795b5cab5c9f22be37c784789ddd63ef";

export default node;
